"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInputFieldHeightValue = void 0;
const getInputFieldHeightValue = (themeMode, inputFieldHeight) => {
  if (inputFieldHeight) return inputFieldHeight;
  if (themeMode === "lodestar-light") return 40;
  return 32;
};
exports.getInputFieldHeightValue = getInputFieldHeightValue;
//# sourceMappingURL=inputFieldBaseProps.js.map